var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationBell = function SvgNotificationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.244 15.0773C10.1253 15.2819 9.95498 15.4517 9.75 15.5698C9.54502 15.6879 9.31262 15.75 9.07608 15.75C8.83953 15.75 8.60713 15.6879 8.40215 15.5698C8.19718 15.4517 8.02681 15.2819 7.90812 15.0773M13.1268 6.30072C13.1268 5.2264 12.7 4.19608 11.9404 3.43643C11.1807 2.67677 10.1504 2.25 9.07608 2.25C8.00176 2.25 6.97144 2.67677 6.21179 3.43643C5.45213 4.19608 5.02536 5.2264 5.02536 6.30072C5.02536 11.0266 3 12.3768 3 12.3768H15.1522C15.1522 12.3768 13.1268 11.0266 13.1268 6.30072Z",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNotificationBell;